// -> IAuditManager.GetChangeFeedAsync (ChangesController). The roadmap's "Recent changes" card.
//
// A ROADMAP ROUTE SERVED BY THE AUDIT MANAGER, and this module does not need to know that - the
// route is named for the question rather than for the component, the same way /api/data-quality is
// (decisions.md D-258). What matters on this side is the GATE: unlike every other audit route,
// this one is gated on roadmap.view, so a Viewer gets 200 here and 403 on /api/audit. audit.ts is
// still the module for the trail proper and is still an admin-area surface.
//
// THE SENTENCES ARRIVE FINISHED. Nothing in this app composes a change line from parts, because
// nothing is given parts to compose one from - the server never sends an action token, a payload
// or a principal id. A renderer's whole job is to print `sentence`, format `occurredAtUtc` in the
// reader's locale, and badge `category`.
import { http } from "./http";
import type { ChangeFeed } from "./generated/contracts";

export interface ChangeFeedParams {
  /** How far back to look, in days. The server defaults to 30 and caps at 365. */
  readonly days?: number;
  /** How many lines to return. The server defaults to 20 and caps at 200. */
  readonly count?: number;
}

export const changesApi = {
  get: (params: ChangeFeedParams = {}) => http.get<ChangeFeed>("/api/roadmap/changes", { query: { ...params } }),
};
